import { AuthorizationUiState } from '@/store/modules/authorizationUi/types'

export const state: AuthorizationUiState = {
  interacted: false,
  selectedProjectId: '',
  selectedUser: '',
  newUsers: [],
}
